module.exports = __webpack_public_path__ + "static/media/sett.b4ca2a68.png";